"use client";
import { useEffect, useState } from "react";
import { ArrowUpRight, Cloud } from "lucide-react";
import { useT } from "@/components/i18n/I18nProvider";
import { historyUrl, progressConfig } from "@/lib/accountProgress";

export function SaveProgress({ test, compact = false }: { test?: string; compact?: boolean }) {
  const { t, locale } = useT();
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    progressConfig().then(c => { if (active) setEnabled(c.enabled && !c.excluded_tests?.includes(test ?? "")); })
      .catch(() => { if (active) setEnabled(false); });
    return () => { active = false; };
  }, [test]);
  if (!enabled) return null;
  return <aside data-result-action="save-progress" className={`mx-auto my-6 w-full rounded-2xl border border-primary/20 bg-primary-light p-5 text-start ${compact ? "" : "max-w-xl sm:p-7"}`}>
    <div className="flex items-start gap-3"><Cloud className="mt-1 shrink-0 text-primary" size={23} aria-hidden="true" />
      <div><p className="text-lg font-semibold text-foreground">{t("progress.keep_title")}</p><p className="mt-1 text-sm leading-relaxed text-muted-foreground">{t("progress.keep_body")}</p></div>
    </div>
    <div className="mt-5 flex flex-wrap items-center gap-4">
      <a href={historyUrl(locale, true)} className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 font-semibold text-primary-foreground hover:opacity-90">{t("progress.save")}<ArrowUpRight size={17} aria-hidden="true" /></a>
      <a href={historyUrl(locale)} className="text-sm font-semibold text-primary hover:underline">{t("progress.title")}</a>
    </div>
  </aside>;
}
